import React from 'react';
import { Toaster } from 'sonner';

/**
 * The single app-wide toast host, styled to the Chilli Koala brand
 * (warm cream card, sunny border, rounded bubble). Success and error
 * toasts pick up the brand's green/coral accent on the border.
 *
 * Always use `toast` from "sonner" — the shadcn use-toast system was
 * removed in favour of this one host.
 */
export const BrandToaster = () => (
  <Toaster
    position="top-center"
    duration={3000}
    swipeDirections={['top', 'left', 'right']}
    // Wider than sonner's 356px default: celebration toasts carry Chilli art
    // plus a title and a description, which the default width crams onto
    // three lines. (Below 600px sonner goes full-width and ignores this.)
    style={{ '--width': '420px' } as React.CSSProperties}
    toastOptions={{
      style: {
        background: '#FFF9F0', // koala-background
        border: '2px solid #FFD93D', // koala-secondary
        borderRadius: '1.25rem',
        color: '#2D3436', // koala-text
        boxShadow: '0 6px 0 0 rgba(255, 127, 107, 0.15)',
        fontWeight: 500,
        // #root is centred (a Vite-template leftover) and the toast inherits
        // it, which leaves the text drifting away from its icon.
        textAlign: 'left',
      },
      classNames: {
        success: '!border-[#4EAF63]',
        error: '!border-[#FF6B6B]',
        title: 'font-semibold',
        // sonner sizes the icon slot for a 16px svg; Chilli art needs room.
        icon: '!mr-2.5 !h-11 !w-11',
      },
    }}
  />
);
